import { LuChevronRight, LuMenu } from 'react-icons/lu';

function AdminTopbar({ title, onOpenNavigation }) {
  return (
    <header className="admin-topbar">
      <button className="admin-mobile-menu" aria-label="Open navigation" onClick={onOpenNavigation}><LuMenu size={21} /></button>
      <div className="workspace-crumb"><span>Operations</span><LuChevronRight size={14} /><strong>{title}</strong></div>
    </header>
  );
}

export default AdminTopbar;
